// extracted by mini-css-extract-plugin
export default {"labelSecondary":"nCK6reYkf0gALzoEZ8iD"};